import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { SessionGate } from '@/app/session';
import { BreadcrumbsProvider } from './breadcrumbs';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import s from './AppShell.module.css';

/** Navigation resets the scroll to the top (DESIGN_SPEC §6); tab changes inside a page keep it. */
function ScrollToTop() {
  const { pathname } = useLocation();
  const section = pathname.split('/').slice(0, 3).join('/');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [section]);
  return null;
}

/** The frame around every signed-in screen: sidebar, sticky header, content. */
export function AppShell() {
  return (
    <SessionGate>
      <BreadcrumbsProvider>
        <ScrollToTop />
        <div className={s.root}>
          <Sidebar />
          <main className={s.main}>
            <Header />
            <div className={s.content}>
              <Outlet />
            </div>
          </main>
        </div>
      </BreadcrumbsProvider>
    </SessionGate>
  );
}
